// extracted by mini-css-extract-plugin
export default {"productSolution":"style_productSolution__Gbcg3"};